<!-- HTML -->
<div class="overlay" [ngStyle]="{position: width ? 'absolute' : 'fixed'}">
    <div class="popup" [ngStyle]="{ width: width ? width + 'px' : 'auto' }">
        <div class=" popup-content w-100 h-100" [ngClass]="{'py-2': !width}">
            <ng-content select="[body]">
            </ng-content>
        </div>
    </div>
</div>